import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { useSEO } from "../hooks/useSEO";
import { site } from "../data/site";

export default function Legal() {
  useSEO({
    title: "Mentions légales | Embèk Group",
    description: "Mentions légales du site Embèk Group : éditeur, hébergement, propriété intellectuelle et crédits.",
  });

  return (
    <>
      <PageHeader eyebrow="Informations légales" title="Mentions légales" />
      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 space-y-6 text-coal-muted font-light leading-relaxed text-[15px]">
          <Reveal>
            <h2 className="font-serif text-2xl text-forest">Éditeur du site</h2>
            <p className="mt-2">
              {site.name} — entreprise de jardinage, entretien et aménagement des espaces verts.
              <br />
              Adresse : Chaussée de Waterloo 200/8, 1640 Rhode-Saint-Genèse, Belgique
              <br />
              Téléphone : {site.phone} — E-mail : {site.email}
              <br />
              Forme juridique et numéro d'entreprise : à renseigner — Numéro de TVA : à renseigner.
            </p>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl text-forest pt-4">Hébergement</h2>
            <p className="mt-2">Hébergeur du site : à renseigner (nom, adresse, téléphone).</p>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl text-forest pt-4">Propriété intellectuelle</h2>
            <p className="mt-2">
              L'ensemble des contenus de ce site (textes, visuels, logo) est la propriété exclusive de {site.name},
              sauf mention contraire. Toute reproduction, même partielle, est interdite sans autorisation préalable.
            </p>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl text-forest pt-4">Photographies</h2>
            <p className="mt-2">
              Les photographies présentées sur ce site sont des visuels de démonstration issus de banques d'images
              professionnelles. Elles seront remplacées par les photos réelles des réalisations de {site.name}.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
